import { Alert, Button, Typography } from 'antd';
import React from 'react';
import { ReactComponent as Download } from '@assets/icons/bulkActions/download.svg';
import Icon from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export default function PremiereProInstallInstructions() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Title level={3}>Install StreamWork Plugin for Adobe Premiere Pro</Title>

      <Paragraph>
        Follow these steps to install the StreamWork plugin in Premiere Pro.
      </Paragraph>

      <ol>
        <li>
          <Paragraph>
            Download the StreamWork plugin for Premiere Pro.
          </Paragraph>
          <Button
            type="primary"
            href="/creative-cloud-plugin/premiere-pro.ccx"
            download="StreamWork Premiere Pro Plugin.ccx"
            icon={<Icon component={Download} />}
            style={{ marginBottom: 16 }}
          >
            Download Plugin
          </Button>
        </li>
        <li>
          <Paragraph>
            Open the downloaded file. Adobe Creative Cloud will automatically
            install the plugin.
          </Paragraph>
        </li>
        <li>
          <Paragraph>Launch or restart Premiere Pro.</Paragraph>
        </li>
        <li>
          <Paragraph>
            You will find the StreamWork panel under{' '}
            <strong>Window &gt; UXP Plugins &gt; StreamWork</strong>.
          </Paragraph>
        </li>
      </ol>
      <Alert
        type="info"
        showIcon
        message="Need help?"
        style={{ marginBottom: 16 }}
        description={
          <Paragraph>
            If you have questions about installing or using the plugin, reach
            out to us at support@streamwork.com or via the in-product chat and
            we’ll be happy to help!
          </Paragraph>
        }
      />
    </div>
  );
}
